// TODO: Reasoning for this functionality
// We are showing the pricing disclaimer when the reduced quote has a specified target country. This is an issue as
// a currency which has no currency union e.g. BWP may show a pricing disclaimer as target country is specified even
// though BWP is only supported by one country.
//
// To combat this, we introduce the concept of currency union. So not only if the target country is specified, it must
// be a currency union of the pricing disclaimer to be shown.
//
// Cons:
// This will not work with global currencies but is not a currency union. i.e. global USD is a concept. So you can send
// USD to a country that doesn't official support it. USD is a currency union so it would matter in this case as a
// pricing disclaimer is valid. But this might be the case in the future with other non union currencies.
//
// Other idea:
// You can take a look at the quotes received and deduce whether or not to show the pricing disclaimer or not. For
// instance, if you have two or more quotes for a given route and provider, you know they could have different prices
// and so show the disclaimer.
//
// Cons:
// You need to have all the available routes and quotes for every provider. It might be the case that we only scrape
// one country for EUR, but the provider supports a lot more. But because one only scrape on country, the pricing
// disclaimer would not turn up.

const currencyUnions = [
  { code: 'XOF' },
  { code: 'XAF' },
  { code: 'XPF' },
  { code: 'XCD' },
  { code: 'EUR' },
  { code: 'HKD' },
  { code: 'SGD' },
  { code: 'AUD' },
  { code: 'GBP' },
  { code: 'INR' },
  { code: 'NZD' },
  { code: 'ILS' },
  { code: 'RUB' },
  { code: 'ZAR' },
  { code: 'CHF' },
  { code: 'USD' },
];

function getAllCurrencyUnions() {
  return currencyUnions;
}

function isCurrencyUnion(code) {
  return getAllCurrencyUnions().find((c) => code === c.code);
}

export { getAllCurrencyUnions, isCurrencyUnion };
